import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import Loader from "../../components/Loader";
import { postApi } from "../../service";

const ShowBetsCR: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [betsList, setBetsList] = useState<any[]>([]);
  const [isLoader, setIsLoader] = useState<boolean>(true);
  const [loadError, setLoadError] = useState("");

  const locationState = location.state as { matchId?: string; selection?: string } | null;
  const matchId = id || locationState?.matchId || searchParams.get("id") || "";
  const selection = locationState?.selection ?? searchParams.get("selection") ?? "";

  useEffect(() => {
    fetchBetsData();
  }, [matchId, selection]);

  const fetchBetsData = async () => {
    setIsLoader(true);
    setLoadError("");
    if (!matchId || !selection) {
      setBetsList([]);
      setLoadError("Match or market is missing.");
      setIsLoader(false);
      return;
    }
    try {
      const res = await postApi({
        api: "getBetsByMatch",
        value: {
          id: matchId,
          selection,
        },
      });
      const rows = res?.data?.data;
      setBetsList(Array.isArray(rows) ? rows : []);
    } catch (error) {
      console.error("Error fetching admin/getBetsByMatch data:", error);
      setBetsList([]);
      setLoadError("Could not load bets.");
    }
    setIsLoader(false);
  };

  const money = (value: any) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return "0.00";
    return amount.toFixed(2);
  };

  return (
    <>
      <style>{`
        .show-bets-cr-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
          border: none;
        }
        .show-bets-cr-table th {
          background: #E4E4E4 !important;
          color: #1e1e1e;
          font-weight: 700;
          border: none !important;
          border-top: 1px solid rgb(126, 151, 167) !important;
          border-bottom: 1px solid rgb(126, 151, 167) !important;
          padding: 6px 8px;
          text-align: right;
          white-space: nowrap;
        }
        .show-bets-cr-table td {
          border: none !important;
          border-bottom: 1px solid #ffffff !important;
          padding: 8px;
          font-size: 12px;
          color: #000;
          text-align: right;
          white-space: nowrap;
        }
        .show-bets-cr-table tbody tr:last-child td {
          border-bottom: 1px solid rgb(126, 151, 167) !important;
        }
        .show-bets-cr-row-back {
          background-color: #7CC4F7 !important;
        }
        .show-bets-cr-row-lay {
          background-color: #FCA4B7 !important;
        }
        .show-bets-pnl {
          color: #111 !important;
          font-weight: 700 !important;
          min-width: 72px;
        }
        .show-bets-action-btn {
          background-color: #FFB80C;
          color: #000;
          border: 1px solid #000;
          font-weight: bold;
          padding: 4px 14px;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
        }
        .show-bets-action-btn:hover {
          background-color: #ffc83d;
        }
      `}</style>

      <>{isLoader && <Loader />}</>
      <div className="container full-wrap">
        <div className="top_header">
          <div className="top_header_title">
            <h5>Show Bet</h5>
          </div>
        </div>

        <section className="my-account-section">
          <div
            className="my-account-section_header"
            style={{
              padding: "6px 10px",
              background: "#E0E6E6",
              borderBottom: "1px solid #7e97a7",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <button
              type="button"
              className="show-bets-action-btn"
              onClick={() => navigate(-1)}
              style={{
                backgroundColor: "rgb(255, 184, 12)",
                color: "rgb(0, 0, 0)",
                border: "1px solid rgb(0, 0, 0)",
                padding: "7px 12px",
              }}
            >
              Back
            </button>
            <button
              type="button"
              className="show-bets-action-btn"
              style={{
                backgroundColor: "rgb(255, 184, 12)",
                color: "rgb(0, 0, 0)",
                border: "1px solid rgb(0, 0, 0)",
                padding: "7px 12px",
              }}
            >
              Live Match bet
            </button>
            <button
              type="button"
              className="show-bets-action-btn"
              style={{
                backgroundColor: "rgb(255, 184, 12)",
                color: "rgb(0, 0, 0)",
                border: "1px solid rgb(0, 0, 0)",
                padding: "7px 12px",
              }}
            >
              Rejected Bets
            </button>
          </div>

          <div
            className="my-account-section-content-table"
            style={{ marginTop: "10px" }}
          >
            <div style={{ overflowX: "auto" }}>
              <table className="show-bets-cr-table">
                <thead>
                  <tr>
                    <th style={{ width: "6%" }}>Sports</th>
                    <th style={{ width: "12%" }}>Match Name</th>
                    <th style={{ width: "8%" }}>Client</th>
                    <th style={{ width: "8%" }}>Type</th>
                    <th style={{ width: "8%" }}>Selection</th>
                    <th style={{ width: "6%" }}>Result</th>
                    <th style={{ width: "5%" }}>Odds</th>
                    <th style={{ width: "5%" }}>Stake</th>
                    <th style={{ width: "12%" }}>Place Time</th>
                    <th style={{ width: "18%" }}>IP</th>
                    <th style={{ width: "6%" }}>Pnl</th>
                    <th style={{ width: "6%" }}>Status</th>
                  </tr>
                </thead>
                {!isLoader && (
                  <tbody>
                    {loadError ? (
                      <tr>
                        <td colSpan={12} style={{ textAlign: "center" }}>
                          {loadError}
                        </td>
                      </tr>
                    ) : betsList.length === 0 ? (
                      <tr>
                        <td colSpan={12} style={{ textAlign: "center" }}>
                          No bets
                        </td>
                      </tr>
                    ) : (
                      betsList.map((bet: any, index: number) => {
                        const isLay = bet.betSide === "lay" || bet.betSide === "no";
                        const rowClass = isLay
                          ? "show-bets-cr-row-lay"
                          : "show-bets-cr-row-back";
                        return (
                          <tr key={bet._id || index} className={rowClass}>
                            <td style={{ textAlign: "right" }}>{bet.type}</td>
                            <td style={{ textAlign: "right" }}>
                              {bet.matchId?.name}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {bet.userId?.user_name}
                            </td>
                            <td style={{ textAlign: "right" }}>{bet.betType}</td>
                            <td style={{ textAlign: "right" }}>{bet.selection}</td>
                            <td style={{ textAlign: "right" }}>{bet.winner}</td>
                            <td style={{ textAlign: "right" }}>{bet.oddsUp}</td>
                            <td style={{ textAlign: "right" }}>{bet.stake}</td>
                            <td style={{ textAlign: "right" }}>
                              {bet.createdAt
                                ? moment(bet.createdAt).format(
                                    "YYYY-MM-DD HH:mm:ss",
                                  )
                                : ""}
                            </td>
                            <td style={{ textAlign: "right" }}>{bet.ip || ""}</td>
                            <td className="show-bets-pnl" style={{ textAlign: "right" }}>
                              {money(
                                bet.playerPnl != null ? bet.playerPnl : bet.profit,
                              )}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {bet.resultStatus || ""}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ShowBetsCR;
